import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * Grouped form area with a clear section title.
 */
export default function FormSection({ title, description, step, children, sx, fillHeight = false }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 'var(--radius-lg)',
        bgcolor: 'background.paper',
        ...(fillHeight
          ? {
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              overflow: 'hidden',
            }
          : {}),
        ...sx,
      }}
    >
      {(title || description || step != null) && (
      <Box sx={{ mb: fillHeight ? 1.5 : 2, flexShrink: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          {step != null && (
            <Typography
              component="span"
              variant="caption"
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 'var(--radius-pill)',
                bgcolor: 'var(--color-primary-50)',
                color: 'primary.main',
                fontWeight: 700,
              }}
            >
              Step {step}
            </Typography>
          )}
          {title && (
            <Typography variant="subtitle1" fontWeight={600} color="text.primary">
              {title}
            </Typography>
          )}
        </Box>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      )}
      <Box
        sx={
          fillHeight
            ? {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
              }
            : undefined
        }
      >
        {children}
      </Box>
    </Paper>
  );
}
